import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';
import moment from 'moment';

import { TOUR_SHOWING_STATUS_FAILED } from 'common/tourConstants';

class SrTourCopyAllAddressesHeader extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    listings: PropTypes.array.isRequired,
    showings: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      showClickedTooltip: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onCopyAllAddressesClick = (e) => {
    const { user, listings, showings } = this.props;
    e.preventDefault();
    e.stopPropagation();

    const listingAddresses = listings
      .filter(({ id }) => {
        const showing = showings.find(({ listingId }) => listingId === id);
        return showing.status !== TOUR_SHOWING_STATUS_FAILED;
      })
      .map((listing) => {
        return (
          `${listing.addressStreetDisplay}, ${listing.addressCity}, ` +
          `${listing.addressStateCode}, ${listing.addressZip}`
        );
      }).join('\n');

    copyToClipboard(
      `${user.phone}\n\n` +
      `${listingAddresses}\n\n` +
      `${moment().format('h:mma MM/DD')}`
    );

    this.setState({
      showClickedTooltip: true,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          showClickedTooltip: false,
        });
      }
    }, 2000);
  }

  render() {
    const { showClickedTooltip } = this.state;

    return (
      <span
        onClick={this._onCopyAllAddressesClick}
        className='copyAllAddresses'
      >
        <span className='secondaryAction'>
          listing
          <span
            className={classnames(
              'copiedMessage',
              'addressesCopyAllMessage',
              showClickedTooltip && 'clicked',
            )}
          >
            Copied addresses to clipboard!
          </span>
        </span>
      </span>
    );
  }
}

SrTourCopyAllAddressesHeader.displayName = 'SrTourCopyAllAddressesHeader';

export default SrTourCopyAllAddressesHeader;
